import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontPlayfairDisplay, fontSourceSerif4, theme } from "shared/lib/styles";

import type { ContentHeadlineVariant } from "scmp-app/components/content/content-headline";

export const FlagDivider = styled.span``;

type FlagProps = {
  $color?: string;
  $variant?: ContentHeadlineVariant;
};

export const Flag = styled.span<FlagProps>`
  color: ${props => props.$color ?? "#666666"};

  ${props =>
    props.$variant === "generic" &&
    css`
      inline-size: fit-content;

      color: ${props.$color === "#2aa191" ? "#2aa191" : "#727272"};
      font-weight: 600;
      font-size: 20px;
      font-family: ${fontSourceSerif4};
      font-style: italic;
      line-height: 100%;
      letter-spacing: -0.5px;

      ${theme.breakpoints.up("tablet")} {
        font-size: 24px;
        letter-spacing: -0.6px;
      }
    `}

  ${props =>
    props.$variant === "magazines-style" &&
    css`
      color: #222222;
      font-family: ${fontPlayfairDisplay};
      text-transform: uppercase;

      span {
        font-style: italic;
      }

      ${FlagDivider} {
        font-style: normal;
      }
    `}
`;
